import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkuRoutingModule } from './sku-routing.module';
import { ProductoComponent } from './producto/producto.component';
import { ResourcesModule } from '../resources/resources.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TextareaModule } from 'primeng/textarea';
import { ImageModule } from 'primeng/image';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { InventarioComponent } from './inventario/inventario.component';
import { ListaPreciosComponent } from './lista-precios/lista-precios.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { MovimientosComponent } from './movimientos/movimientos.component';
import { MovimientosAdmComponent } from './movimientos-adm/movimientos-adm.component';
import { AccordionModule } from 'primeng/accordion';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
  declarations: [ProductoComponent, InventarioComponent, ListaPreciosComponent, MovimientosComponent, MovimientosAdmComponent],
  imports: [
    CommonModule,
    SkuRoutingModule,
    ResourcesModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcesModule,
    ButtonModule,
    InputTextModule,
    AutoCompleteModule,
    TextareaModule,
    ImageModule,
    FileUploadModule, ConfirmDialogModule,
    ToastModule, DividerModule, CheckboxModule, DialogModule, CardModule, AccordionModule, CalendarModule,
    PaginatorModule,
    SelectModule,
    InputNumberModule,
    TabsModule,
    ToggleSwitchModule
    
  ]
})
export class SkuModule { }
